import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import { basketEvents } from '../../services/analytics/analytics';
import { ItemEditBtns } from '../../services/itemeditbtns/itemeditbtns';
import { number_format, num_word, fastBuy, normalizeStockStatusCode, stockPositiveTotal, markClass } from '../../tools/functions';


export const CatalogCard = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number],
        item: [Object, Array],
    },
    computed: {
        ...mapState(vplSiteStore, ['basket','compare','favorite', 'SITE_TEMPLATE_PATH'])
    },
    methods: {
        number_format: number_format,
        num_word: num_word,
        fastBuy: fastBuy,
        normalizeStockStatusCode: normalizeStockStatusCode,
        stockPositiveTotal: stockPositiveTotal,
        markClass: markClass,
        sendFavorite(id){
            $.ajax({
                url: '/ajax/favorite.php',
                method: 'POST',
                data: {id: id},
                success: (response) => {
                    try {
                        const favoriteData = JSON.parse(response);
                        const store = vplSiteStore();
                        store.favorite = favoriteData;
                    }catch(err){ }
                }
            });
        },
        sendCompare(id){
            $.ajax({
                url: '/ajax/compare.php',
                method: 'POST',
                data: {id: id},
                success: (response) => {
                    try {
                        const compareData = JSON.parse(response);
                        const store = vplSiteStore();
                        store.compare = compareData;

                        this.$emit('compare-process');
                    }catch(err){ }
                }
            });
        },
        addToBasket(id){
            if($(this.$el).find('.js-cart-btn').hasClass('in-basket')){
              VplRouter('/cart/');
            }else{
              $.ajax({
                  url: '/ajax/basket.php',
                  method: 'POST',
                  data: {action: 'add', id: id, 'count': $(this.$el).find(".js-input-touchspin").val()},
                  success: (response) => {
                      try {
                          const basketData = JSON.parse(response);
                          basketEvents(basketData);
                          const store = vplSiteStore();
                          store.basket = basketData;
                      }catch(err){ }
                  }
              });
            }
        },
        changeQuantity(e){
            this.pendingQuantity = $(e.target).val();

            if(this.quantityTimeout){
                clearTimeout(this.quantityTimeout);
            }

            this.quantityTimeout = setTimeout(() => {
                this.sendQuantityChange();
            }, 300);
        },
        sendQuantityChange(){
            if(
                this.quantityRequest
                || this.pendingQuantity === null
            ){
                return;
            }

            const quantity = this.pendingQuantity;
            this.pendingQuantity = null;

            this.quantityRequest = $.ajax({
                url: '/ajax/basket.php',
                method: 'POST',
                data: {
                    action: 'change',
                    id: this.item.ID,
                    count: quantity
                },
                success: (response) => {
                    try {
                        const basketData = JSON.parse(response);
                        // дельта каждого ответа реальна, даже если сам ответ промежуточный
                        basketEvents(basketData);

                        /*
                         * Не применяем промежуточный ответ,
                         * если пользователь уже выбрал новое количество.
                         */
                        if(this.pendingQuantity === null){
                            const store = vplSiteStore();
                            store.basket = basketData;
                        }
                    }catch(err){ }
                },
                complete: () => {
                    this.quantityRequest = null;

                    /*
                     * Если во время запроса количество изменилось,
                     * отправляем только последнее значение.
                     */
                    if(this.pendingQuantity !== null){
                        this.sendQuantityChange();
                    }
                }
            });
        },
        bindQuantityChange(){
            const $input = $(this.$el)
                .find('.js-input-touchspin');

            if(!$input.length){
                return;
            }

            $input
                .off('change.catalogCardQuantity')
                .on(
                    'change.catalogCardQuantity',
                    (e) => {
                        this.changeQuantity(e);
                    }
                );
        }
    },
    updated(){
        const $input = $(this.$el)
            .find('.js-input-touchspin');

        if(!$input.length){
            return;
        }

        if(
            !$input
                .parent()
                .hasClass('bootstrap-touchspin')
        ){
            $input.TouchSpin();
        }

        this.bindQuantityChange();
    },
    mounted(){
        this.quantityTimeout = null;
        this.quantityRequest = null;
        this.pendingQuantity = null;

        const $input = $(this.$el)
            .find('.js-input-touchspin');

        $input.show();

        if(
            !$input
                .parent()
                .hasClass('bootstrap-touchspin')
        ){
            $input.TouchSpin();
        }

        this.bindQuantityChange();
    },
    beforeUnmount(){
        if(this.quantityTimeout){
            clearTimeout(this.quantityTimeout);
        }

        if(this.quantityRequest){
            this.quantityRequest.abort();
        }

        $(this.$el)
            .find('.js-input-touchspin')
            .off('.catalogCardQuantity');
    },
    template: `

        <div class="product-card js-card" :key="'triend-' + this.item.ID" :data-id="this.item.ID">
            <ItemEditBtns v-if="this.item.EDIT_BUTTON" :onclick="this.item.EDIT_BUTTON">
                Редактировать элемент
            </ItemEditBtns>
            <div class="product-card__top">
                <a :href="this.item.DETAIL_PAGE_URL" class="product-card__img" :class="{'no-photo': this.item.IMAGE === false}">
                    <img v-if="this.item.IMAGE !== false" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="this.item.IMAGE" :alt="this.item.NAME" :title="this.item.NAME">
                    <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="this.item.NAME" :title="this.item.NAME">
                </a>
                <a :href="this.item.DETAIL_PAGE_URL" class="product-card__name" v-html="this.item.NAME">
                </a>
                <ul class="product-card__chars">
                    <template v-for="prop in this.item.DISPLAY_PROPERTIES">
                        <li v-if="prop.VALUE">
                            <div class="product-card__chars-name">{{prop.NAME}}</div>
                            <div class="product-card__chars-value">{{prop.VALUE}}</div>
                        </li>
                    </template>
                </ul>
            </div>
            <div class="product-card__wp">
                <div v-if="this.item.MARKS && this.item.MARKS.length" class="product-card__tags">
                    <div v-for="mark in this.item.MARKS" :key="mark.CODE" class="product-card__tags-item" :class="markClass(mark.CODE)">{{ mark.NAME }}</div>
                </div>
                <div v-else-if="this.item.PROMO || this.item.HIT || this.item.SALE || this.item.NEW" class="product-card__tags">
                    <div v-if="this.item.PROMO" class="product-card__tags-item promo">Акция</div>
                    <div v-if="this.item.HIT" class="product-card__tags-item hit">Хит продаж</div>
                    <div v-if="this.item.SALE" class="product-card__tags-item sale">Распродажа</div>
                    <div v-if="this.item.NEW" class="product-card__tags-item new">Новинка</div>
                </div>
                <div v-if="Object.keys(this.favorite).includes(''+this.item.ID)" class="product-card__del product-card__fav-del" @click.prevent="sendFavorite(this.item.ID)">
                    <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                </div>
                <div v-if="Object.keys(this.compare).includes(''+this.item.ID)" class="product-card__del product-card__compare-del" @click.prevent="sendCompare(this.item.ID)">
                    <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                </div>
                <div class="product-card__amount">
                    <div v-if="normalizeStockStatusCode(this.item.STOCK_STATUS_CODE) == 'in_stock'" class="product-card__amount-item amount">В наличии · {{ stockPositiveTotal(this.item.STOCK_POSITIVE_TOTAL) }} шт.</div>
                    <div v-else-if="normalizeStockStatusCode(this.item.STOCK_STATUS_CODE) == 'to_order'" class="product-card__amount-item delivery">Под заказ</div>
                </div>
                <div class="product-card__info">
                    <div v-if="this.item.PRICE.PRICE" class="product-card__price">
                        {{ number_format(this.item.PRICE.PRICE, 0, '.', ' ') }} ₽
                        <div class="product-card__price-old" v-if="this.item.PRICE.PRICE != this.item.PRICE.BASE_PRICE">
                            <span>{{ number_format(parseInt(this.item.PRICE.BASE_PRICE), 0, '.', ' ') }} ₽ </span>
                            <div v-if="this.item.PRICE.PERCENT" class="product-card__price-discount">{{this.item.PRICE.PERCENT}}%</div>
                        </div>
                    </div>
                    <div class="product-card__info-actions">
                        <div class="product-card__info-actions-top">

                            <div
                                    v-if="normalizeStockStatusCode(this.item.STOCK_STATUS_CODE) == 'individual_calculation'"
                                    class="product-card__basket"
                                >
                                    <a
                                        href="#"
                                        class="product-card__basket-btn tas-individual-calc-btn"
                                        @click.prevent="fastBuy(this.item.ID, 'Запросить расчет')"
                                    >
                                        <div class="product-card__basket-btn-icon">
                                            <svg class="ico ico-calc" width="20" height="20" aria-hidden="true"><use xlink:href="#ico-calc"></use></svg>
                                        </div>
                                        Рассчитать
                                    </a>
                                </div>

                                <div
                                    v-else-if="normalizeStockStatusCode(this.item.STOCK_STATUS_CODE) == 'in_stock' || normalizeStockStatusCode(this.item.STOCK_STATUS_CODE) == 'to_order'"
                                    class="product-card__basket"
                                    :class="{'in-basket': this.basket.ITEMS[this.item.ID] !== undefined}"
                                >
                                    <a
                                        href="#"
                                        class="product-card__basket-btn"
                                        @click.prevent="addToBasket(this.item.ID)"
                                    >
                                        <div class="product-card__basket-btn-icon">
                                            <span class="product-card__basket-btn-icon-process">
                                                <svg class="ico ico-in-process" width="19" height="19" aria-hidden="true"><use xlink:href="#ico-in-process"></use></svg>
                                            </span>
                                            <svg class="icon icon-basket">
                                                <use xlink:href="#icon-basket"></use>
                                            </svg>
                                        </div>
                                        Купить
                                    </a>

                                    <div class="product-card__basket-amount">
                                        <input
                                            type="text"
                                            aria-label=""
                                            class="input-touchspin js-input-touchspin"
                                            :value="this.basket.ITEMS[this.item.ID] !== undefined ? this.basket.ITEMS[this.item.ID].QUANTITY : 1"
                                        >
                                        <a href="/cart/" class="product-card__basket-amount-text">
                                            В корзине
                                        </a>
                                    </div>
                                </div>

                                <div
                                    v-else
                                    class="product-card__basket"
                                ></div>

                                <div class="product-card__info-actions-rightside">
                                <a href="#" class="product-card__info-actions-item" :class="{'is-active': Object.keys(this.compare).includes(''+this.item.ID)}" @click.prevent="sendCompare(this.item.ID)">
                                    <div class="product-card__info-actions-item-informer">
                                        Сравнить
                                    </div>
                                    <svg class="icon icon-compare"><use xlink:href="#icon-compare"></use></svg>
                                </a>
                                <a href="#" class="product-card__info-actions-item" :class="{'is-active': Object.keys(this.favorite).includes(''+this.item.ID)}" @click.prevent="sendFavorite(this.item.ID)">
                                    <div class="product-card__info-actions-item-informer">
                                        В избранное
                                    </div>
                                    <svg class="icon icon-fav"><use xlink:href="#icon-fav"></use></svg>
                                </a>
                            </div>
                        </div>
                        <a v-if="false && (this.item.QUANTITY > 0 || this.item.TO_ORDER == 'Y')" href="#" class="product-card__buy" @click.prevent="fastBuy(this.item.ID)">Купить в 1 клик</a>
                    </div>
                </div>
            </div>
        </div>
    `
}